import { STORAGE_KEYS, type TransferDirection } from '@flowshare/protocol';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface HistoryEntry {
  id: string;
  fileName: string;
  fileSize: number;
  direction: TransferDirection;
  peerName: string;
  status: 'completed' | 'failed' | 'cancelled';
  startedAt: number;
  completedAt: number;
  sha256: string | null;
  storageKey: string | null;
  error: string | null;
}

interface HistoryStore {
  entries: HistoryEntry[];
  add: (entry: HistoryEntry) => void;
  remove: (id: string) => void;
  clear: () => void;
  forgetStoredFiles: () => void;
}

const MAX_ENTRIES = 200;

export const useHistoryStore = create<HistoryStore>()(
  persist(
    (set) => ({
      entries: [],
      add: (entry) =>
        set((state) => ({
          entries: [entry, ...state.entries.filter((existing) => existing.id !== entry.id)].slice(
            0,
            MAX_ENTRIES,
          ),
        })),
      remove: (id) => set((state) => ({ entries: state.entries.filter((e) => e.id !== id) })),
      clear: () => set({ entries: [] }),
      forgetStoredFiles: () =>
        set((state) => ({
          entries: state.entries.map((entry) => (entry.storageKey ? { ...entry, storageKey: null } : entry)),
        })),
    }),
    {
      name: STORAGE_KEYS.history,
      version: 1,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ entries: state.entries }),
    },
  ),
);
